import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'

const useStyles = makeStyles((theme) => ({
    backLink: {
        display: 'inline-flex',
        alignItems: 'center',
        color: '#202020',
        fontSize: '14px',
        fontFamily: 'sans-serif',
        fontWeight: '400',
        position: 'relative',
        right: '5px',
        '&:hover': {
            cursor: 'pointer',
            textDecoration: 'underline',
        },
        '&:focus': {
            textDecoration: 'underline',
        },
    },
    backArrowIcon: {
        marginRight: '0.5rem',
    },
}))

const BackButton = ({
    tabIndex = 0,
    backAction,
    ariaText = '',
    buttonText = '',
    className = '',
}) => {
    const classes = useStyles()

    return (
        <span
            data-testid={`back-button-${tabIndex}`}
            role="button"
            tabIndex={tabIndex}
            className={`${classes.backLink} ${className}`}
            onClick={backAction}
            onKeyPress={(e) => {
                if (e.key === 'Enter') {
                    backAction()
                }
            }}
            aria-label={ariaText}
        >
            <KeyboardArrowLeftIcon /> {buttonText}
        </span>
    )
}

export default BackButton
